import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Link2 } from 'lucide-react';

export const LinkCodePopover = ({ initial, label, onSave, busy, testId }) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState(initial || '');
  const save = async () => {
    if (!code.trim()) return;
    const ok = await onSave(code.trim());
    if (ok !== false) setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (v) setCode(initial || ''); }}>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline" className="h-7 text-xs" disabled={busy} data-testid={testId}>
          <Link2 className="w-3 h-3 mr-1" /> {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 space-y-2" align="end">
        <p className="text-xs text-muted-foreground">Enter the exact AccountsIQ code.</p>
        <Input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
          className="font-mono h-8"
          autoFocus
          data-testid={`${testId}-input`}
        />
        <Button size="sm" className="w-full h-8" onClick={save} disabled={!code.trim() || busy} data-testid={`${testId}-save`}>
          Link
        </Button>
      </PopoverContent>
    </Popover>
  );
};
